<script src="./Toast.js"></script>
<style lang="scss" src="./Toast.scss"></style>
<template>
    <div class="custom-toast" v-if="isShowToast">
        <div class="overlay"></div>
        <div :class="type ? ('custom-toast-body '+type) : ('custom-toast-body')">{{ message }} <a class="custom-toast-close" @click="closeToast">X</a></div>
    </div>
</template>